// Composition root: the one place that wires the tabs surface's concrete
// widgets into the registry. Add a new one with an import + list entry.
import { tabsWidgetRegistry } from '@/core/widgets/export';
import { BulletListWidget, TechnicalAnalysisWidgetFactory } from '@/modules/articles/export';
import { TabsCalendarWidgetFactory } from '@/modules/calendar/export';

[
  new BulletListWidget(
    'all-bullets',
    [
      'fx-bullets',
      'fi-bullets',
      'em-bullets',
      'eu-credit-bullets',
      'eu-fi-bullets',
      'us-credit-bullets',
      'us-hy-credit-bullets',
      'em-credit-bullets',
      'oil-bullets',
      'power-bot',
      'gas-bullets',
      'us-oil',
      'us-gas-bullets',
      'commodities-macro-bullets',
    ],
    {
      title: 'All Bullets',
      titleSubstitutions: [{ codes: ['us-oil', 'us-gas-bullets'], name: 'US O&G' }],
    },
    'All',
  ),
  new BulletListWidget('dm-bullets', ['fx-bullets', 'fi-bullets'], { title: 'DM Bullets' }, 'FX'),
  new BulletListWidget(
    'energy-bullets',
    ['oil-bullets', 'power-bot', 'gas-bullets', 'commodities-macro-bullets'],
    {
      title: 'Energy Bullets',
    },
    'Energy',
  ),
].forEach(widget => tabsWidgetRegistry.register(widget));

[new TabsCalendarWidgetFactory(), new TechnicalAnalysisWidgetFactory()].forEach(factory =>
  tabsWidgetRegistry.registerFactory(factory),
);
